import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lojas vêm SEMPRE da conta logada (nunca uma lista fixa de outra conta)
export function useLojas() {
  const [lojas, setLojas] = useState([]);
  useEffect(() => {
    axios.get(`${API}/config/lojas`)
      .then((r) => setLojas(r.data?.lojas || []))
      .catch(() => setLojas([]));
  }, []);
  return lojas;
}

export function useLojasInfo() {
  const [info, setInfo] = useState({ lojas: [], slugs: {}, empresa: "" });
  useEffect(() => {
    axios.get(`${API}/config/lojas`)
      .then((r) => setInfo({ lojas: r.data?.lojas || [], slugs: r.data?.slugs || {}, empresa: r.data?.empresa || "" }))
      .catch(() => {});
  }, []);
  return info;
}
